import gql from 'graphql-tag';

const adjustContractMutation = gql`
  mutation adjustContractItem(
    $organisationId: String!,
    $type: String!,
    $owner: String!,
    $amount: Int!,
    $reason: String!,
    $notes: String,
    $adjustFor: String,
    $ghosteeUserEmail: String) {
  adjustContractItem(
    organisationId: $organisationId,
    type: $type,
    owner: $owner,
    amount: $amount,
    reason: $reason,
    notes: $notes,
    adjustFor: $adjustFor,
    ghosteeUserEmail: $ghosteeUserEmail
  )}
`;

const adjustContract = () => ({
  mutation: adjustContractMutation,
  module: 'organisations',
  buildVariables: ({
    type,
    owner,
    amount,
    reason,
    notes,
    adjustFor,
    organisationId,
    ghosteeUserEmail









  }) => ({
    type,
    owner,
    amount,
    reason,
    notes,
    adjustFor,
    organisationId,
    ghosteeUserEmail
  })
});

export default adjustContract;